<template>
  <div class="undo-redo-container">
    <div class="buttons-container">
      <div :style="undoDisabledStyle" :class="undoButtonClass" draggable="false">
        <div class="undo-redo-img svg-img" @click="undoOnClick">
          <UndoIcon />
        </div>
      </div>
      <div :style="redoDisabledStyle" :class="redoButtonClass" draggable="false">
        <div class="undo-redo-img svg-img" @click="redoOnClick">
          <RedoIcon />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FeatureGating from '@/services/FeatureGating';
import UndoIcon from '@/components/AvatarBuilderUI/UndoIcon';
import RedoIcon from '@/components/AvatarBuilderUI/RedoIcon';

export default {
  name: 'UndoRedoButton',
  components: {
    UndoIcon,
    RedoIcon,
  },
  methods: {
    undoOnClick: function() {
      this.$store.commit('undoAvatarAction');
    },
    redoOnClick: function() {
      this.$store.commit('redoAvatarAction');
    },
  },
  computed: {
    redoDisabledStyle: function() {
      if (this.$store.getters.avatarActionIndex < 0 || this.$store.getters.disableUndoRedoButton) {
        return {
          opacity: '0.2',
          // pointerEvents makes the button unclickable
          pointerEvents: 'none',
        };
      }
      return {};
    },
    undoDisabledStyle: function() {
      if (
        this.$store.getters.avatarActionIndex >= this.$store.getters.avatarActions.length ||
        this.$store.getters.avatarActions.length === 0 ||
        this.$store.getters.disableUndoRedoButton
      ) {
        return {
          opacity: '0.2',
          // pointerEvents makes the button unclickable
          pointerEvents: 'none',
        };
      }
      return {};
    },
    undoButtonClass() {
      return FeatureGating.isHighlightedUndoRedoEnabled()
        ? 'highlighted-undo-button'
        : 'undo-button';
    },
    redoButtonClass() {
      return FeatureGating.isHighlightedUndoRedoEnabled()
        ? 'highlighted-redo-button'
        : 'redo-button';
    },
  },
};
</script>

<style scoped>
.undo-redo-container {
  position: absolute;
  /* bottom half of web builder is 52% */
  bottom: 52%;
  left: 0;
  /* visibility is needed to show opacity in iOS */
  visibility: visible;
}

.buttons-container {
  position: relative;
  bottom: 2px;
}

.undo-button,
.highlighted-undo-button {
  left: 15px;
}

.redo-button,
.highlighted-redo-button {
  left: 20px;
}

.undo-button,
.redo-button {
  cursor: pointer;
  position: relative;
  display: inline-block;
}

.highlighted-undo-button {
  cursor: pointer;
  position: relative;
  display: inline-block;
  background-color: black;
  opacity: 0.75;
  height: 35px;
  width: 45px;
  border-radius: 20px 3px 3px 20px;
  margin-bottom: 5px;
}

.highlighted-redo-button {
  cursor: pointer;
  position: relative;
  display: inline-block;
  background-color: black;
  opacity: 0.75;
  height: 35px;
  width: 45px;
  border-radius: 3px 20px 20px 3px;
  margin-bottom: 5px;
}

.undo-redo-img {
  height: 30px;
  width: 36px;
}
@media (orientation: landscape) {
  .undo-redo-container {
    bottom: 0;
  }
}
</style>
